<template>
  <div
    v-if="!questionnaire.summarySheet"
    :style="'--max-height:' + 94 * (crew.triads.length ? crew.triads.length : 1) + 'px'"
  >
    <AccordionMarkProfileComponent
      :mark="markApprentice"
      :markSignatory="questionnaire.markSignatory"
      :profile="1"
      :questionnaire="questionnaire"
      :triad="triad"
    />
    <AccordionMarkProfileComponent
      :mark="markTutor"
      :markSignatory="questionnaire.markSignatory"
      :profile="2"
      :questionnaire="questionnaire"
      :triad="triad"
    />
    <AccordionMarkProfileComponent
      :mark="markApprenticeMaster"
      :markSignatory="questionnaire.markSignatory"
      :profile="3"
      :questionnaire="questionnaire"
      :triad="triad"
    />
    <AccordionMarkProfileComponent
      :mark="markStudeaManager"
      :markSignatory="questionnaire.markSignatory"
      :profile="4"
      :questionnaire="questionnaire"
      :triad="triad"
    />
  </div>
  <div
    v-else
    :style="'--max-height:' + 94 * (crew.triads.length ? crew.triads.length : 1) + 'px'"
    class="d-flex align-items-center justify-content-center"
  >
    <AccordionMarkSummarySheetComponent :mark="markSummarySheet" :questionnaire="questionnaire" :triad="triad" />
  </div>
</template>

<script>
import AccordionMarkProfileComponent from "@/components/table/accordion/AccordionMarkProfileComponent.vue";
import AccordionMarkSummarySheetComponent from "@/components/table/accordion/AccordionMarkSummarySheetComponent.vue";

export default {
  name: "AccordionNoteReplyComponent",
  components: { AccordionMarkSummarySheetComponent, AccordionMarkProfileComponent },
  props: {
    triad: {
      type: Object,
      required: true,
    },
    crew: {
      type: Object,
      required: true,
    },
    questionnaire: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: "mark",
    },
  },
  data() {
    return {
      markApprentice: null,
      markTutor: null,
      markApprenticeMaster: null,
      markStudeaManager: null,
      markSummarySheet: null,
    };
  },
  mounted() {
    if (this.questionnaire && this.questionnaire[this.type] && this.questionnaire[this.type][this.triad.id]) {
      let mark = this.questionnaire[this.type][this.triad.id];
      this.markApprentice = Object.values(mark).find((m) => m.profile === 1);
      this.markTutor = Object.values(mark).find((m) => m.profile === 2);
      this.markApprenticeMaster = Object.values(mark).find((m) => m.profile === 3);
      this.markStudeaManager = Object.values(mark).find((m) => m.profile === 4);
    }

    if (this.questionnaire.summarySheet) {
      this.markSummarySheet = this.questionnaire.summarySheetMark[this.triad.id];
    }
  },
};
</script>

<style lang="scss" scoped></style>
